import script from "./Steps.vue?vue&type=script&setup=true&lang=ts"
export * from "./Steps.vue?vue&type=script&setup=true&lang=ts"

import "./Steps.vue?vue&type=style&index=0&id=36044729&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36044729"]])

export default __exports__